import { render, staticRenderFns } from "./EpBenefitCard.vue?vue&type=template&id=145c8b2d&"
import script from "./EpBenefitCard.vue?vue&type=script&lang=js&"
export * from "./EpBenefitCard.vue?vue&type=script&lang=js&"
import style0 from "./EpBenefitCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports